"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const environment_enum_1 = require("../enums/environment.enum");
class UsersEndpointsService {
    constructor(params) {
        this.endpoints = {
            baseUrl: '',
            serviceUrls: {
                consent: '/consent',
                roles: '/authorization',
                state: {
                    enable: '/enable',
                    disable: '/disable'
                }
            }
        };
        if (!!params) {
            this.endpoints = params;
        }
        else {
            const enviromnent = params;
            switch (enviromnent) {
                case environment_enum_1.EnvironmentEnum.STAGING:
                    this.endpoints.baseUrl = `${UsersEndpointsService.BASE_URLS[environment_enum_1.EnvironmentEnum.STAGING]}/`;
                    break;
                default:
                    this.endpoints.baseUrl = `${UsersEndpointsService.BASE_URLS[environment_enum_1.EnvironmentEnum.LIVE]}/`;
                    break;
            }
        }
    }
    getBaseUrl() {
        return this.endpoints.baseUrl;
    }
    getConsentUrl() {
        return this.endpoints.serviceUrls.consent;
    }
    getRolesUrl() {
        return this.endpoints.serviceUrls.roles;
    }
    getStateUrls() {
        return {
            enable: this.endpoints.serviceUrls.state.enable,
            disable: this.endpoints.serviceUrls.state.disable
        };
    }
}
UsersEndpointsService.BASE_URLS = {
    [environment_enum_1.EnvironmentEnum.STAGING]: 'https://api-staging.empathybroker.com/user/v1/user',
    [environment_enum_1.EnvironmentEnum.LIVE]: 'https://api.empathybroker.com/user/v1/user'
};
exports.UsersEndpointsService = UsersEndpointsService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlcnMtZW5kcG9pbnRzLnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VydmljZXMvdXNlcnMtZW5kcG9pbnRzLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxnRUFBNEQ7QUFHNUQ7SUFrQkUsWUFBWSxNQUEwQztRQVpyQyxjQUFTLEdBQW1CO1lBQzNDLE9BQU8sRUFBRSxFQUFFO1lBQ1gsV0FBVyxFQUFFO2dCQUNYLE9BQU8sRUFBRSxVQUFVO2dCQUNuQixLQUFLLEVBQUUsZ0JBQWdCO2dCQUN2QixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxFQUFFLFNBQVM7b0JBQ2pCLE9BQU8sRUFBRSxVQUFVO2lCQUNwQjthQUNGO1NBQ0YsQ0FBQztRQUdBLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBbUIsTUFBTyxDQUFDLENBQUMsQ0FBQztZQUNoQyxJQUFJLENBQUMsU0FBUyxHQUFHLE1BQXdCLENBQUM7UUFDNUMsQ0FBQztRQUFDLElBQUksQ0FBQyxDQUFDO1lBQ04sTUFBTSxXQUFXLEdBQXNCLE1BQU8sQ0FBQztZQUMvQyxNQUFNLENBQUMsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDO2dCQUNwQixLQUFLLGtDQUFlLENBQUMsT0FBTztvQkFDMUIsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLEdBQUcsR0FBSSxxQkFBcUIsQ0FBQyxTQUFTLENBQUMsa0NBQWUsQ0FBQyxPQUFPLENBQUUsR0FBRyxDQUFDO29CQUMxRixLQUFLLENBQUM7Z0JBQ1I7b0JBQ0UsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLEdBQUcsR0FBSSxxQkFBcUIsQ0FBQyxTQUFTLENBQUMsa0NBQWUsQ0FBQyxJQUFJLENBQUUsR0FBRyxDQUFDO29CQUN2RixLQUFLLENBQUM7WUFDVixDQUFDO1FBQ0gsQ0FBQztJQUNILENBQUM7SUFFTSxVQUFVO1FBQ2YsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDO0lBQ2hDLENBQUM7SUFFTSxhQUFhO1FBQ2xCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUM7SUFDNUMsQ0FBQztJQUVNLFdBQVc7UUFDaEIsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQztJQUMxQyxDQUFDO0lBRU0sWUFBWTtRQUNqQixNQUFNLENBQUM7WUFDTCxNQUFNLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUMsS0FBSyxDQUFDLE1BQU07WUFDL0MsT0FBTyxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQyxPQUFPO1NBQ2xELENBQUM7SUFDSixDQUFDOztBQWxEdUIsK0JBQVMsR0FBRztJQUNsQyxDQUFDLGtDQUFlLENBQUMsT0FBTyxDQUFDLEVBQUUsb0RBQW9EO0lBQy9FLENBQUMsa0NBQWUsQ0FBQyxJQUFJLENBQUMsRUFBRSw0Q0FBNEM7Q0FDckUsQ0FBQztBQUpKLHNEQW9EQyJ9